import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import './css/HeaderNav.css';
// import logo from '../assets/images/nimble only logo.png';

const Header = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      if (window.innerWidth > 768) {
        setMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const businessVerticals = [
    { 
      text: 'Aromatic Chemicals & Derivatives', 
      path: '/business/aromatic-chemicals' 
    },
    { 
      text: 'Eco-Friendly & Sustainable Solutions', 
      path: '/business/eco-friendly-solutions' 
    },
    { 
      text: 'Heat Dissipation Compounds', 
      path: '/business/heat-dissipation' 
    },
    { 
      text: 'Green Metal Working Additives', 
      path: '/business/green-metal-working' 
    }
  ];

  const navLinks = [
    { 
      text: 'HOME', 
      path: '/' 
    },
    { 
      text: 'WHO WE ARE', 
      path: '/about' 
    },
    { 
      text: 'BUSINESS VERTICALS', 
      path: '/business',
      hasDropdown: true,
      dropdownItems: businessVerticals
    },
    { 
      text: 'EHS & SUSTAINABILITY', 
      path: '/ehs-sustainability' 
    },
    { 
      text: 'WHY NIMBLE', 
      path: '/expertise' 
    },
    { 
      text: 'BEYOND BUSINESS', 
      path: '/responsibilities' 
    },
    { 
      text: 'LET’S CONNECT', 
      path: '/contact' 
    }
  ];

  return (
    <motion.header 
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className={`header ${mobileMenuOpen ? 'mobile-open' : ''}`}
    >
      <div className="header-container">
        <motion.div 
          className="logo-container"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          {/* <Link to="/">
            <img src={logo} alt="Nimble Logo" className="logo" />
          </Link> */}
        </motion.div>

        <button 
          className="mobile-menu-toggle" 
          onClick={toggleMobileMenu}
          aria-label="Toggle navigation menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`header-nav ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <div className="nav-links-container">
            {navLinks.map((link, index) => (
              <motion.div
                key={link.text}
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                  duration: 0.5,
                  delay: 0.2 + index * 0.1,
                  ease: "easeOut"
                }}
                className={link.hasDropdown ? "dropdown-container" : ""}
                onClick={() => windowWidth <= 768 && setMobileMenuOpen(false)}
              >
                {link.hasDropdown ? (
                  <div 
                    className="dropdown-trigger"
                    onMouseEnter={() => windowWidth > 768 && setDropdownOpen(true)}
                    onMouseLeave={() => windowWidth > 768 && setDropdownOpen(false)}
                  >
                    <Link 
                      to={link.path}
                      className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
                    >
                      {link.text}
                    </Link>
                    <div className={`dropdown-menu ${dropdownOpen ? 'show' : ''}`}>
                      {link.dropdownItems.map((item) => (
                        <Link 
                          key={item.text}
                          to={item.path} 
                          className="dropdown-item"
                        >
                          {item.text}
                        </Link>
                      ))}
                    </div>
                  </div>
                ) : (
                  <Link 
                    to={link.path}
                    className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
                  >
                    {link.text}
                  </Link>
                )}
              </motion.div>
            ))}
          </div>
        </nav>
      </div>
    </motion.header>
  );
};

export default Header;